module.exports = __webpack_public_path__ + "assets/qr-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/qr-btn-icon.svg
// module id = 817
// module chunks = 0